function trimNullEntries(item) {
  if (Array.isArray(item)) {
    item = item.filter(i => {
      if (i) {
        return true;
      }
      else {
        return false;
      }
    });
    item = item.map(i => {
      i = trimNullEntries(i);
      return i;
    });
  }
  else {
    for (let key in item) {
      if (key) {
        if (item[key] == null || item[key] == undefined) {
          delete item[key];
        }
        else {
          if (Array.isArray(item[key])) {
            item[key] = trimNullEntries(item[key]);
          }
        }
      }
    }
  }
  return item;
}

let apiFilters = {
  projectFilters: {
    projectCollectionShallow: {
      filter: {
        include: ['project_type', 'project_template', 'location', 'company', 'location.market', 'location.location_users', 'project_manager'],
        fields: {
          project: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'archived_at', 'status', 'root_build_id', 'project_type', 'location', 'company', 'is_favorite', 'project_manager'],
          market: ['id', 'name', 'code'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          company: ['id', 'name'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role', 'companies', 'company_vendor_users', 'profile_image'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market', 'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          project_manager: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
        },
      },
      get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        return record;
      },
    },

    projectCollectionDeep: {
      filter: {
        include: ['project_type',
          'project_template',
          'location',
          'location.market',
          'location.location_users',
          'documents',
          'closeouts',
          'closeouts.closeouts',
          'closeouts.user',
          'builds.closeouts',
          'tasks',
          'tasks.closeouts',
          'tasks.completion_criteria',
          'tasks.completion_criteria.attachments',
          'tasks.completion_criteria.comments',
          'tasks.completion_criteria.status',
          'tasks.completion_criteria.attachments.user',
          'tasks.completion_criteria.attachments.upload',
          'tasks.completion_criteria.attachments'],
        fields: {
          project: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'archived_at', 'status', 'root_build_id', 'project_type',
            'location', 'documents', 'closeouts', 'builds', 'tasks', 'is_favorite', 'notes'],
          build: ['id', 'name', 'closeouts'],
          market: ['id', 'name', 'code'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market',
            'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role', 'companies', 'company_vendor_users', 'profile_image'],
          task: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required', 'completion_percentage', 'order',
            'task_attachments_count', 'build_id', 'project_id',
            'closeouts',
            'completion_criteria'],
          attachment: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'user', 'upload', 'completion_name', 'photo_latitude', 'photo_longitude', 'photo_taken_at'],
          document: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'user', 'upload', 'completion_name'],
          completion_criterion: ['id', 'task_id', 'name', 'instructions', 'order', 'reviewed_at', 'approved_at', 'rejected_at', 'completed_at', 'completion_type', 'not_applicable',
            'response', 'comments', 'attachments', 'status', 'requested_file_type'],
          closeout: ['id', 'name', 'duration', 'size', 'status', 'key', 'expiring_url', 'created_at', 'updated_at', 'closeouts'],
        },
      },
      get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        return record;
      },
    },
    projectWithBuilds: {
      filter: {
        include: ['project_manager',
          'users',
          'project_users',
          'project_users.user',
          'project_users.user.role',
          'project_type',
          'project_template',
          'users.role',
          'users.companies',
          'users.company_vendor_users',
          'location',
          'location.market',
          'location.location_users',
          'custom_project_settings',
          'company',
          'builds',
          'builds.builds',
          'builds.user_build_assignments',
          'builds.user_build_assignments.user'],
        fields: {
          project: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'status', 'root_build_id', 'users', 'notes',
            'project_manager',
            'project_users',
            'project_type',
            'project_template',
            'location',
            'custom_project_settings',
            'company',
            'builds',
            'is_favorite'],
          market: ['id', 'name', 'code'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market', 'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          company: ['id', 'name'],
          comment: ['id', 'user_id', 'body', 'caption', 'created_at'],
          project_user: ['id', 'user_id', 'assignment_type', 'created_at', 'user'],
          custom_project_setting: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value', 'integer_value,  :boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role', 'companies', 'company_vendor_users', 'profile_image'],
          project_manager: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
          company_vendor_user: ['id', 'vendor_user', 'company'],
          role: ['id', 'name'],
          build: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'builds', 'user_build_assignments'],
          user_build_assignment: ['id', 'user_id', 'assignment_type', 'user', 'created_at', 'user'],
          builds: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'user_build_assignments'],
        },
      },
      get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        record.builds = record.builds ? record.builds.filter(build => {
          if (build.ancestry) {
            let levels = build.ancestry.split('/');
            if (levels.length <= 1) {
              return true;
            }
            else {
              return false;
            }
          }
          else {
            return false;
          }
        }) : [];
        return record;
      },
    },

    locationProjectWithBuilds: {
      filter: {
        include: ['project_manager',
          'users',
          'project_users',
          'project_users.user',
          'project_type',
          'project_template',
          'users.role',
          'users.companies',
          'users.company_vendor_users',
          'location',
          'location.market',
          'location.location_users',
          'custom_project_settings',
          'company',
          'builds',
          'builds.builds',
          'builds.user_build_assignments',
          'builds.user_build_assignments.user'],
        fields: {
          project: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'status', 'root_build_id', 'users', 'notes',
            'project_manager',
            'project_users',
            'project_type',
            'project_template',
            'location',
            'custom_project_settings',
            'company',
            'builds'],
          market: ['id', 'name', 'code'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market', 'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          company: ['id', 'name'],
          comment: ['id', 'user_id', 'body', 'caption', 'created_at'],
          project_user: ['id', 'user_id', 'assignment_type', 'created_at', 'user'],
          custom_project_setting: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value', 'integer_value,  :boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role', 'companies', 'company_vendor_users', 'profile_image'],
          project_manager: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
          company_vendor_user: ['id', 'vendor_user', 'company'],
          role: ['id', 'name'],
          build: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'builds', 'user_build_assignments'],
          user_build_assignment: ['id', 'user_id', 'assignment_type', 'user', 'created_at', 'user'],
          builds: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'user_build_assignments'],
        },
      },
      get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        record.builds = record.builds.filter(build => {
          if (build.ancestry) {
            let levels = build.ancestry.split('/');
            if (levels.length <= 1) {
              return true;
            }
            else {
              return false;
            }
          }
          else {
            return false;
          }
        });
        return record;
      },
    },

    projectWithBuildsAndTasks: {
      filter: {
        include: ['project_manager',
          'users',
          'project_users',
          'project_users.user',
          'project_type',
          'project_template',
          'users.role',
          'users.companies',
          'users.company_vendor_users',
          'location',
          'location.market',
          'location.location_users',
          'custom_project_settings',
          'company',
          'builds',
          'builds.builds',
          'builds.user_build_assignments',
          'builds.user_build_assignments.user',
          'tasks',
          'tasks.user_task_assignments',
          'tasks.completion_criteria',
          'tasks.completion_criteria.attachments',
          'tasks.completion_criteria.comments',
          'tasks.completion_criteria.status',
          'tasks.completion_criteria.attachments.user',
          'tasks.completion_criteria.attachments.upload',
          'tasks.completion_criteria.attachments'],
        fields: {
          project: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'status', 'root_build_id', 'users', 'notes',
            'project_manager',
            'project_users',
            'project_type',
            'project_template',
            'location',
            'custom_project_settings',
            'company',
            'builds',
            'tasks'],
          market: ['id', 'name', 'code'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market', 'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          company: ['id', 'name'],
          comment: ['id', 'user_id', 'body', 'caption', 'created_at'],
          project_user: ['id', 'user_id', 'assignment_type', 'created_at', 'user'],
          custom_project_setting: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value', 'integer_value,  :boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role', 'companies', 'company_vendor_users', 'profile_image'],
          project_manager: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
          company_vendor_user: ['id', 'vendor_user', 'company'],
          role: ['id', 'name'],
          build: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'builds', 'user_build_assignments'],
          user_build_assignment: ['id', 'user_id', 'assignment_type', 'user', 'created_at', 'user'],
          task: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required', 'completion_percentage', 'order',
            'task_attachments_count', 'build_id', 'project_id',
            'completion_criteria', 'user_task_assignments'],
          attachment: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'user', 'upload', 'photo_latitude', 'photo_longitude', 'photo_taken_at'],
          completion_criterion: ['id', 'task_id', 'name', 'instructions', 'order', 'reviewed_at', 'approved_at', 'rejected_at', 'completed_at', 'completion_type', 'not_applicable',
            'response', 'comments', 'attachments', 'requested_file_type'],
          user_task_assignment: ['id', 'user_id', 'assignment_type', 'user', 'created_at', 'user'],
          builds: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'user_build_assignments'],
        },
      },
      get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        return record;
      },
    },

    projectWithTasks: {
      filter: {
        include: ['project_manager',
          'users',
          'project_users',
          'project_users.user',
          'users.role',
          'users.companies',
          'users.company_vendor_users',
          'location',
          'location.market',
          'location.location_users',
          'company',
          'tasks',
          'tasks.user_task_assignments',
          'tasks.user_task_assignments.user',
          'tasks.completion_criteria',
          'tasks.completion_criteria.attachments',
          'tasks.completion_criteria.comments',
          'tasks.completion_criteria.status',
          'tasks.completion_criteria.attachments.user',
          'tasks.completion_criteria.attachments.upload',
          'tasks.completion_criteria.attachments'],
        fields: {
          project: ['id', 'name', 'notes', 'guid', 'created_at', 'root_build_id', 'builds_count', 'tasks_count', 'tasks_completed_count', 'archived_at', 'status', 'project_manager',
            'users',
            'project_users', 'location', 'company', 'tasks'],
          user_task_assignment: ['id', 'user_id', 'assignment_type', 'user', 'created_at', 'user'],
          company: ['id', 'name'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          comment: ['id', 'user_id', 'body', 'caption', 'created_at'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market', 'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          project_user: ['id', 'user_id', 'assignment_type', 'created_at', 'user'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role',
            'companies',
            'company_vendor_users', 'profile_image'],
          project_manager: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
          market: ['id', 'name', 'code'],
          company_vendor_user: ['id', 'vendor_user', 'company'],
          role: ['id', 'name'],
          task: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required', 'completion_percentage', 'order',
            'task_attachments_count', 'build_id', 'project_id',
            'completion_criteria', 'user_task_assignments'],
          attachment: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'user', 'upload', 'photo_latitude', 'photo_longitude', 'photo_taken_at'],
          completion_criterion: ['id', 'task_id', 'name', 'instructions', 'order', 'reviewed_at', 'approved_at', 'rejected_at', 'completed_at', 'completion_type', 'not_applicable',
            'response', 'comments', 'attachments', 'requested_file_type'],
        },
      },
      get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        record = record.map(project => {
          project.tasks = project.tasks.map(task => {
            switch (task.status) {
            case 'not started':
              task.status = 'not_started';
              break;
            case 'in progress':
              task.status = 'in_progress';
              break;
            case 'pending review':
              task.status = 'pending_review';
              break;
            case 'pending approval':
              task.status = 'pending_approval';
              break;
            default:
              break;
            }
            return task;
          });
          return project;
        });
        return record;
      },
    },

    projectFlat: {
      filter: {
        include: ['project_manager',
          'users',
          'project_users',
          'project_users.user',
          'project_type',
          'project_template',
          'users.role',
          'users.companies',
          'users.company_vendor_users',
          'location',
          'location.market',
          'location.location_users',
          'custom_project_settings',
          'company'],
        fields: {
          project: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'status', 'root_build_id', 'users', 'notes',
            'project_manager',
            'project_users',
            'project_type',
            'project_template',
            'location',
            'custom_project_settings',
            'company'],
          market: ['id', 'name', 'code'],
          project_type: ['id', 'name'],
          project_template: ['id', 'name', 'version', 'group_identifier'],
          location: ['id', 'name', 'city', 'state', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes', 'market', 'location_users'],
          location_user: ['id', 'location_id', 'user_id', 'user'],
          company: ['id', 'name'],
          comment: ['id', 'user_id', 'body', 'caption', 'created_at'],
          project_user: ['id', 'user_id', 'assignment_type', 'created_at', 'user'],
          custom_project_setting: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value', 'integer_value,  :boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
          user: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'role', 'companies', 'company_vendor_users', 'profile_image'],
          project_manager: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
          company_vendor_user: ['id', 'vendor_user', 'company'],
          role: ['id', 'name'],
        },
      }, get encodedFilter() {
        if (!this.encoded) {
          this.encoded = encodeURI(JSON.stringify(this.filter));
        }
        return this.encoded;
      },
      postProcess(record) {
        record = trimNullEntries(record);
        return record;
      },
    },
  },
};

export default apiFilters;



// WEBPACK FOOTER //
// ./src/helpers/apiFilterConstants.js